"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateColorText = exports.generateColor = void 0;

// generate string to color
var stringToColour = function stringToColour(str) {
  var hash = 0;

  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  var colour = "#";

  for (var _i = 0; _i < 3; _i++) {
    var value = hash >> _i * 8 & 0xff;
    colour += ("00" + value.toString(16)).substr(-2);
  }

  return colour;
};

var generateColor = function generateColor(name) {
  return stringToColour(name);
}; // generate hex to RGBA


exports.generateColor = generateColor;

var hexToRgbA = function hexToRgbA(hex) {
  var c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");

    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = "0x" + c.join("");
    return {
      r: c >> 16 & 255,
      g: c >> 8 & 255,
      b: c & 255
    };
  }

  throw new Error("Bad Hex");
}; // generate color white or black


var textColor = function textColor(bgColor) {
  var r = bgColor.r,
      g = bgColor.g,
      b = bgColor.b;
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "black" : "white";
};

var generateColorText = function generateColorText(hex) {
  return textColor(hexToRgbA(hex));
};

exports.generateColorText = generateColorText;